import React from 'react'
import '../styles/app.css'

const Loading = (props: { type: string, text?: string }) => {

  const displayLoading = ()  => {
    switch (props.type) {
      case "medium":
        return (
          <div className="spin-wrap">
              <div className="spin">
                  <em className="spin-icon dsicon dsicon-loading"></em>
              </div>
           </div>
        )
      case "large":
          return (
            <div className="spin-wrap spin-lg">
                <div className="spin">
                    <em className="spin-icon dsicon dsicon-loading"></em>
                </div>
             </div>
          )
      case "text":
        return (
          <div className="spin-wrap">
              <div className="spin">
                  <em className="spin-icon dsicon dsicon-loading"></em>
                  <span className="spin-text">Loading...</span>
              </div>
          </div>
        )
      case "large-text":
        return (
          <div className="spin-wrap spin-lg">
              <div className="spin">
                  <em className="spin-icon dsicon dsicon-loading"></em>
                  <span className="spin-text">{props.text}</span>
              </div>
          </div>
        )
      default:
        return (
          <div className="spin-wrap spin-sm">
              <div className="spin">
                  <em className="spin-icon dsicon dsicon-loading"></em>
              </div>
          </div>
        )
    }
  }

  return (
    <>
      { displayLoading() }
    </>
  )
}

export default Loading
